import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useManageRoutes } from '@hooks';

const POSRouter = () => {
  const history = useHistory();
  const routeDirection = useManageRoutes();
  const { pathname } = useLocation();

  useEffect(() => {
    if (routeDirection.length === 0) return;

    history.push(routeDirection, { from: pathname });
  }, [routeDirection]); // eslint-disable-line

  return null;
};

export default POSRouter;
